import axios from 'axios';
import API_V2_URL from '@/constants/API_V2_URL';

const folderStatusService = {
  getFolderStatuses() {
    return axios.get(`${API_V2_URL()}/system/folder_statuses`);
  },
};

export default folderStatusService;



// WEBPACK FOOTER //
// ./src/services/system/FolderStatusService.js